const learningModes = {
  theory:
    "W teorii i przykładach poznasz metodę krok po kroku i zobaczysz poprawny zapis obliczeń.",
  practice:
    "W ćwiczeniach rozwiążesz losowane przykłady, sprawdzisz odpowiedź i w razie potrzeby rozwiniesz wyjaśnienie.",
  quiz:
    "W quizie sprawdzisz, czy samodzielnie stosujesz poznaną metodę i poprawnie zapisujesz wynik.",
};

const schoolTopic = (topic) => ({
  useRealTheory: true,
  modeGuide: learningModes,
  ...topic,
});

export const basicSchoolSeoTopicRegistry = [
  schoolTopic({
    slug: "dodawanie-pisemne",
    lessonId: "1_8_1",
    title: "Dodawanie pisemne",
    seoTitle: "Dodawanie pisemne – przykłady i zadania | Matematron",
    seoDescription:
      "Naucz się dodawania pisemnego krok po kroku. Zobacz przykłady z przenoszeniem, rozwiąż ćwiczenia online i sprawdź wynik w quizie.",
    seoNote:
      "Poznaj dodawanie pisemne krok po kroku: ustawianie cyfr w kolumnach, przenoszenie dziesiątek i kontrolę otrzymanego wyniku.",
    relatedSlugs: ["odejmowanie-pisemne", "mnozenie-pisemne", "dzielenie-pisemne"],
    faq: [
      { q: "Jak ustawić liczby do dodawania pisemnego?", a: "Jedności zapisujemy pod jednościami, dziesiątki pod dziesiątkami, a setki pod setkami." },
      { q: "Co robimy, gdy suma w kolumnie jest większa od 9?", a: "Zapisujemy cyfrę jedności, a pozostałą dziesiątkę przenosimy do następnej kolumny." },
      { q: "Od której strony zaczynamy dodawanie pisemne?", a: "Zaczynamy od prawej strony, czyli od kolumny jedności." },
      { q: "Jak sprawdzić wynik dodawania pisemnego?", a: "Można dodać liczby w innej kolejności albo oszacować wynik przed dokładnym obliczeniem." },
    ],
  }),
  schoolTopic({
    slug: "odejmowanie-pisemne",
    lessonId: "1_8_2",
    title: "Odejmowanie pisemne",
    seoTitle: "Odejmowanie pisemne – przykłady i zadania | Matematron",
    seoDescription:
      "Naucz się odejmowania pisemnego krok po kroku. Przećwicz pożyczanie z sąsiedniej kolumny, rozwiąż zadania i sprawdź odpowiedzi.",
    seoNote:
      "Przećwicz odejmowanie pisemne z pożyczaniem: poprawne ustawienie liczb, kolejne kolumny i sprawdzanie wyniku za pomocą dodawania.",
    relatedSlugs: ["dodawanie-pisemne", "mnozenie-pisemne", "dzielenie-pisemne"],
    faq: [
      { q: "Jak ustawić liczby do odejmowania pisemnego?", a: "Cyfry o tej samej wartości pozycyjnej zapisujemy dokładnie jedna pod drugą." },
      { q: "Co zrobić, gdy górna cyfra jest mniejsza od dolnej?", a: "Pożyczamy jedną dziesiątkę z kolumny po lewej, czyli zwiększamy górną cyfrę o 10." },
      { q: "Od której strony odejmujemy pisemnie?", a: "Obliczenia zaczynamy od prawej strony, od kolumny jedności." },
      { q: "Jak sprawdzić odejmowanie pisemne?", a: "Do różnicy dodajemy odjemnik. Jeśli otrzymamy odjemną, wynik jest poprawny." },
    ],
  }),
  schoolTopic({
    slug: "mnozenie-pisemne",
    lessonId: "1_8_3",
    title: "Mnożenie pisemne",
    seoTitle: "Mnożenie pisemne – przykłady i zadania | Matematron",
    seoDescription:
      "Mnożenie pisemne wyjaśnione krok po kroku. Naucz się zapisywać iloczyny cząstkowe, rozwiąż ćwiczenia online i wykonaj quiz.",
    seoNote:
      "Zobacz, jak wykonać mnożenie pisemne przez liczbę jedno- i wielocyfrową oraz jak poprawnie ustawić i dodać iloczyny cząstkowe.",
    relatedSlugs: ["dodawanie-pisemne", "dzielenie-pisemne", "odejmowanie-pisemne"],
    faq: [
      { q: "Od której cyfry zaczynamy mnożenie pisemne?", a: "Zaczynamy od cyfry jedności mnożnika, czyli od jego prawej strony." },
      { q: "Czym są iloczyny cząstkowe?", a: "To wyniki mnożenia całej liczby kolejno przez każdą cyfrę mnożnika." },
      { q: "Dlaczego drugi iloczyn cząstkowy przesuwamy w lewo?", a: "Bo odpowiada mnożeniu przez dziesiątki; kolejne wiersze mogą odpowiadać setkom i dalszym pozycjom." },
      { q: "Jak sprawdzić wynik mnożenia pisemnego?", a: "Można wykonać dzielenie przez jeden z czynników lub oszacować rząd wielkości wyniku." },
    ],
  }),
  schoolTopic({
    slug: "dzielenie-pisemne",
    lessonId: "1_8_4",
    title: "Dzielenie pisemne",
    seoTitle: "Dzielenie pisemne – przykłady i zadania | Matematron",
    seoDescription:
      "Dzielenie pisemne krok po kroku, także z resztą. Zobacz zapis obliczeń, rozwiąż ćwiczenia online i sprawdź odpowiedź w quizie.",
    seoNote:
      "Naucz się dzielenia pisemnego: wybierania kolejnej części dzielnej, zapisywania cyfr ilorazu, odejmowania i obliczania reszty.",
    relatedSlugs: ["mnozenie-pisemne", "odejmowanie-pisemne", "dodawanie-pisemne"],
    faq: [
      { q: "Jak wykonać dzielenie pisemne?", a: "Kolejno dzielimy, mnożymy, odejmujemy i sprowadzamy następną cyfrę dzielnej." },
      { q: "Gdzie zapisujemy wynik dzielenia pisemnego?", a: "Cyfry ilorazu zapisujemy nad odpowiednimi cyframi dzielnej." },
      { q: "Jaka może być reszta z dzielenia?", a: "Reszta jest zawsze liczbą nieujemną mniejszą od dzielnika." },
      { q: "Jak sprawdzić dzielenie z resztą?", a: "Mnożymy iloraz przez dzielnik i dodajemy resztę. Powinniśmy otrzymać dzielną." },
    ],
  }),
  schoolTopic({
    slug: "ulamki-zwykle",
    lessonId: "1_10_1",
    title: "Ułamki zwykłe i ułamki równoważne",
    seoTitle: "Ułamki zwykłe i równoważne – nauka i zadania | Matematron",
    seoDescription:
      "Poznaj licznik i mianownik, skracanie oraz rozszerzanie ułamków. Zobacz przykłady ułamków równoważnych i rozwiąż ćwiczenia online.",
    seoNote:
      "Poznaj budowę ułamka zwykłego oraz naucz się skracać i rozszerzać ułamki bez zmiany ich wartości.",
    relatedSlugs: ["porownywanie-ulamkow", "ulamki-niewlasciwe-i-liczby-mieszane", "dodawanie-i-odejmowanie-ulamkow-zwyklych"],
    faq: [
      { q: "Co oznacza licznik ułamka?", a: "Licznik mówi, ile równych części całości bierzemy." },
      { q: "Co oznacza mianownik ułamka?", a: "Mianownik mówi, na ile równych części podzielono całość; nie może być równy zero." },
      { q: "Kiedy dwa ułamki są równoważne?", a: "Gdy przedstawiają tę samą wartość, mimo że mają inne liczniki i mianowniki." },
      { q: "Jak skrócić ułamek?", a: "Dzielimy licznik i mianownik przez tę samą liczbę różną od zera." },
    ],
  }),
  schoolTopic({
    slug: "ulamki-niewlasciwe-i-liczby-mieszane",
    lessonId: "1_10_6",
    title: "Ułamki niewłaściwe i liczby mieszane",
    seoTitle: "Ułamki niewłaściwe i liczby mieszane | Matematron",
    seoDescription:
      "Zamieniaj ułamki niewłaściwe na liczby mieszane i odwrotnie. Poznaj prostą metodę, przykłady krok po kroku i zadania online.",
    seoNote:
      "Naucz się rozpoznawać ułamki niewłaściwe oraz zamieniać je na liczby mieszane i liczby mieszane na ułamki niewłaściwe.",
    relatedSlugs: ["ulamki-zwykle", "porownywanie-ulamkow", "dodawanie-i-odejmowanie-ulamkow-zwyklych"],
    faq: [
      { q: "Co to jest ułamek niewłaściwy?", a: "To ułamek, którego licznik jest większy od mianownika lub mu równy." },
      { q: "Co to jest liczba mieszana?", a: "To zapis złożony z części całkowitej oraz ułamka właściwego." },
      { q: "Jak zamienić ułamek niewłaściwy na liczbę mieszaną?", a: "Dzielimy licznik przez mianownik; iloraz jest częścią całkowitą, a reszta nowym licznikiem." },
      { q: "Jak zamienić liczbę mieszaną na ułamek niewłaściwy?", a: "Mnożymy część całkowitą przez mianownik, dodajemy licznik, a mianownik pozostawiamy bez zmiany." },
    ],
  }),
  schoolTopic({
    slug: "porownywanie-ulamkow",
    lessonId: "1_10_2",
    title: "Porównywanie ułamków",
    seoTitle: "Porównywanie ułamków – zasady i zadania | Matematron",
    seoDescription:
      "Naucz się porównywać ułamki o równych i różnych mianownikach. Zobacz przykłady, sprowadzanie do wspólnego mianownika i ćwiczenia.",
    seoNote:
      "Porównuj ułamki za pomocą wspólnego mianownika, wspólnego licznika oraz odniesienia do zera, jednej drugiej i jedności.",
    relatedSlugs: ["ulamki-zwykle", "dodawanie-i-odejmowanie-ulamkow-zwyklych", "ulamki-niewlasciwe-i-liczby-mieszane"],
    faq: [
      { q: "Jak porównać ułamki o jednakowych mianownikach?", a: "Większy jest ułamek z większym licznikiem." },
      { q: "Jak porównać ułamki o jednakowych licznikach?", a: "Dla dodatnich ułamków większy jest ten, który ma mniejszy mianownik." },
      { q: "Jak porównać ułamki o różnych mianownikach?", a: "Sprowadzamy je do wspólnego mianownika, a następnie porównujemy liczniki." },
      { q: "Czy można porównywać ułamki przez mnożenie na krzyż?", a: "Tak, dla dodatnich mianowników porównujemy odpowiednie iloczyny licznika i mianownika." },
    ],
  }),
  schoolTopic({
    slug: "dodawanie-i-odejmowanie-ulamkow-zwyklych",
    lessonId: "1_10_3",
    title: "Dodawanie i odejmowanie ułamków zwykłych",
    seoTitle: "Dodawanie i odejmowanie ułamków – zadania | Matematron",
    seoDescription:
      "Dodawanie i odejmowanie ułamków zwykłych krok po kroku. Naucz się wyznaczać wspólny mianownik, skracać wynik i ćwicz online.",
    seoNote:
      "Przećwicz dodawanie i odejmowanie ułamków o jednakowych i różnych mianownikach oraz skracanie otrzymanego wyniku.",
    relatedSlugs: ["ulamki-zwykle", "porownywanie-ulamkow", "mnozenie-ulamkow-zwyklych"],
    faq: [
      { q: "Jak dodać ułamki o jednakowych mianownikach?", a: "Dodajemy liczniki, a mianownik pozostawiamy bez zmiany." },
      { q: "Jak dodać ułamki o różnych mianownikach?", a: "Najpierw sprowadzamy je do wspólnego mianownika, a potem dodajemy liczniki." },
      { q: "Jak odjąć ułamki zwykłe?", a: "Postępujemy jak przy dodawaniu, lecz po sprowadzeniu do wspólnego mianownika odejmujemy liczniki." },
      { q: "Czy wynik trzeba skrócić?", a: "Tak, końcowy ułamek warto zawsze zapisać w najprostszej postaci." },
    ],
  }),
  schoolTopic({
    slug: "mnozenie-ulamkow-zwyklych",
    lessonId: "1_10_4",
    title: "Mnożenie ułamków zwykłych",
    seoTitle: "Mnożenie ułamków zwykłych – zadania | Matematron",
    seoDescription:
      "Naucz się mnożenia ułamków zwykłych i skracania przed mnożeniem. Zobacz rozwiązania krok po kroku, ćwiczenia online i quiz.",
    seoNote:
      "Mnożenie ułamków zwykłych: skracanie na krzyż, mnożenie liczników i mianowników oraz upraszczanie wyniku.",
    relatedSlugs: ["dzielenie-ulamkow-zwyklych", "dodawanie-i-odejmowanie-ulamkow-zwyklych", "ulamki-zwykle"],
    faq: [
      { q: "Jak mnożyć ułamki zwykłe?", a: "Mnożymy licznik przez licznik i mianownik przez mianownik." },
      { q: "Czy ułamki muszą mieć wspólny mianownik przy mnożeniu?", a: "Nie, wspólny mianownik nie jest potrzebny." },
      { q: "Kiedy można skracać ułamki przed mnożeniem?", a: "Można skrócić dowolny czynnik w liczniku z dowolnym czynnikiem w mianowniku." },
      { q: "Jak pomnożyć ułamek przez liczbę całkowitą?", a: "Liczbę całkowitą zapisujemy jako ułamek z mianownikiem 1 i wykonujemy zwykłe mnożenie." },
    ],
  }),
  schoolTopic({
    slug: "dzielenie-ulamkow-zwyklych",
    lessonId: "1_10_5",
    title: "Dzielenie ułamków zwykłych",
    seoTitle: "Dzielenie ułamków zwykłych – zadania | Matematron",
    seoDescription:
      "Dzielenie ułamków zwykłych wyjaśnione krok po kroku. Naucz się mnożyć przez odwrotność, skracać wynik i rozwiązuj ćwiczenia online.",
    seoNote:
      "Naucz się dzielić ułamki przez zamianę dzielenia na mnożenie przez odwrotność drugiego ułamka.",
    relatedSlugs: ["mnozenie-ulamkow-zwyklych", "dodawanie-i-odejmowanie-ulamkow-zwyklych", "ulamki-zwykle"],
    faq: [
      { q: "Jak dzielić ułamki zwykłe?", a: "Pierwszy ułamek pozostawiamy, dzielenie zamieniamy na mnożenie, a drugi ułamek odwracamy." },
      { q: "Co to jest odwrotność ułamka?", a: "Powstaje po zamianie miejscami licznika i mianownika." },
      { q: "Czy można dzielić przez zero?", a: "Nie. Dzielnik ani ułamek, przez który dzielimy, nie może mieć wartości zero." },
      { q: "Czy po zamianie na mnożenie można skracać?", a: "Tak, przed mnożeniem warto skrócić wspólne czynniki licznika i mianownika." },
    ],
  }),
  schoolTopic({
    slug: "dodawanie-i-odejmowanie-ulamkow-dziesietnych",
    lessonId: "1_11_2",
    title: "Dodawanie i odejmowanie ułamków dziesiętnych",
    seoTitle: "Dodawanie i odejmowanie ułamków dziesiętnych | Matematron",
    seoDescription:
      "Dodawanie i odejmowanie ułamków dziesiętnych krok po kroku. Naucz się ustawiać przecinki w kolumnach i rozwiązuj zadania online.",
    seoNote:
      "Przećwicz pisemne dodawanie i odejmowanie liczb dziesiętnych z poprawnym ustawieniem przecinków i wartości pozycyjnych.",
    relatedSlugs: ["mnozenie-ulamkow-dziesietnych", "dzielenie-ulamkow-dziesietnych", "zaokraglanie-ulamkow-dziesietnych"],
    faq: [
      { q: "Jak ustawić ułamki dziesiętne do dodawania?", a: "Zapisujemy przecinek pod przecinkiem, dzięki czemu jedności, części dziesiąte i setne znajdą się w tych samych kolumnach." },
      { q: "Czy można dopisywać zera na końcu ułamka dziesiętnego?", a: "Tak. Dopisanie zer po ostatniej cyfrze części ułamkowej nie zmienia wartości liczby." },
      { q: "Jak odejmować ułamki dziesiętne?", a: "Ustawiamy przecinki w jednej kolumnie i odejmujemy pisemnie tak jak liczby naturalne." },
      { q: "Gdzie postawić przecinek w wyniku?", a: "Dokładnie w tej samej kolumnie, w której znajdują się przecinki składników lub liczb odejmowanych." },
    ],
  }),
  schoolTopic({
    slug: "mnozenie-ulamkow-dziesietnych",
    lessonId: "1_11_3",
    title: "Mnożenie ułamków dziesiętnych",
    seoTitle: "Mnożenie ułamków dziesiętnych – zadania | Matematron",
    seoDescription:
      "Naucz się mnożyć ułamki dziesiętne. Zobacz, jak policzyć cyfry po przecinku, wykonaj przykłady krok po kroku i ćwiczenia online.",
    seoNote:
      "Mnożenie liczb dziesiętnych: najpierw rachunek bez przecinków, potem poprawne wyznaczenie miejsca przecinka w wyniku.",
    relatedSlugs: ["dodawanie-i-odejmowanie-ulamkow-dziesietnych", "dzielenie-ulamkow-dziesietnych", "zaokraglanie-ulamkow-dziesietnych"],
    faq: [
      { q: "Jak mnożyć ułamki dziesiętne?", a: "Mnożymy liczby jak naturalne, a następnie wstawiamy przecinek w wyniku." },
      { q: "Ile cyfr po przecinku ma wynik mnożenia?", a: "Tyle, ile łącznie cyfr po przecinku miały oba czynniki przed uproszczeniem zapisu." },
      { q: "Jak mnożyć ułamek dziesiętny przez 10, 100 lub 1000?", a: "Przesuwamy przecinek w prawo odpowiednio o jedno, dwa lub trzy miejsca." },
      { q: "Jak sprawdzić miejsce przecinka w wyniku?", a: "Warto najpierw oszacować wynik, zaokrąglając oba czynniki do prostych liczb." },
    ],
  }),
  schoolTopic({
    slug: "dzielenie-ulamkow-dziesietnych",
    lessonId: "1_11_4",
    title: "Dzielenie ułamków dziesiętnych",
    seoTitle: "Dzielenie ułamków dziesiętnych – zadania | Matematron",
    seoDescription:
      "Dzielenie ułamków dziesiętnych krok po kroku. Naucz się przesuwać przecinek w dzielnej i dzielniku oraz ćwicz dzielenie pisemne.",
    seoNote:
      "Naucz się dzielić liczby dziesiętne przez liczbę naturalną i dziesiętną, zachowując wartość ilorazu.",
    relatedSlugs: ["mnozenie-ulamkow-dziesietnych", "dodawanie-i-odejmowanie-ulamkow-dziesietnych", "zaokraglanie-ulamkow-dziesietnych"],
    faq: [
      { q: "Jak dzielić przez ułamek dziesiętny?", a: "Przesuwamy przecinek w dzielniku aż stanie się liczbą naturalną i o tyle samo miejsc przesuwamy go w dzielnej." },
      { q: "Czy przesunięcie przecinka zmienia wynik dzielenia?", a: "Nie, jeśli w dzielnej i dzielniku przesuniemy go o tę samą liczbę miejsc." },
      { q: "Jak dzielić ułamek dziesiętny przez 10, 100 lub 1000?", a: "Przesuwamy przecinek w lewo odpowiednio o jedno, dwa lub trzy miejsca." },
      { q: "Jak sprawdzić wynik dzielenia?", a: "Mnożymy otrzymany iloraz przez dzielnik i porównujemy wynik z dzielną." },
    ],
  }),
  schoolTopic({
    slug: "zaokraglanie-ulamkow-dziesietnych",
    lessonId: "1_11_6",
    title: "Zaokrąglanie i szacowanie ułamków dziesiętnych",
    seoTitle: "Zaokrąglanie ułamków dziesiętnych – zadania | Matematron",
    seoDescription:
      "Naucz się zaokrąglać ułamki dziesiętne i szacować wyniki. Poznaj zasadę zaokrąglania, przykłady krok po kroku i ćwiczenia online.",
    seoNote:
      "Poznaj zasady zaokrąglania liczb dziesiętnych do jedności, części dziesiątych i setnych oraz wykorzystuj szacowanie do kontroli wyników.",
    relatedSlugs: ["dodawanie-i-odejmowanie-ulamkow-dziesietnych", "mnozenie-ulamkow-dziesietnych", "dzielenie-ulamkow-dziesietnych"],
    faq: [
      { q: "Jak zaokrąglić ułamek dziesiętny?", a: "Patrzymy na cyfrę bezpośrednio po prawej stronie miejsca, do którego zaokrąglamy." },
      { q: "Kiedy zwiększamy ostatnią pozostawioną cyfrę?", a: "Gdy pierwsza odrzucana cyfra jest równa 5 lub większa." },
      { q: "Co to jest szacowanie wyniku?", a: "To obliczenie przybliżonej wartości za pomocą prostszych, zaokrąglonych liczb." },
      { q: "Po co szacować przed dokładnym obliczeniem?", a: "Szacowanie pomaga szybko wykryć pomylony przecinek lub wynik o niewłaściwym rzędzie wielkości." },
    ],
  }),
];
